import { S3_TYPE } from "archive/ArchiveStore";
export const OVH_TYPE = "ovh";
export const SECUNET_TYPE = "secunet";
export const S3_COMPATIBLE_OPTIONS = [
  { value: OVH_TYPE, label: "OVH Object Storage" },
  { value: SECUNET_TYPE, label: "Secunet S3 Storage" }
];
export const EXTERNAL_ID_HELP = "External ID for the assume role, used to prevent the confused deputy problem. Only applies when an assume role ARN is provided.";
const NEUTRAL_AUTH_COPY = {
  authTypeLabel: "Authentication Type",
  accessKeyLabel: "Access Key",
  accessKeyHelp: "Your storage access key.",
  secretKeyLabel: "Secret Key",
  secretKeyResetLabel: "Secret Key",
  secretKeyHelp: "Your storage secret key.",
  assumeRoleLabel: "Assume Role (ARN) (optional)",
  assumeRoleHelp: "Resource name with required cross account permission.",
  regionLabel: "Region",
  regionAriaLabel: "Select region",
  regionHelp: "The region for your S3-compatible storage provider.",
  regionRequiredError: "Region is required when using a custom endpoint.",
  externalIdLabel: "External ID (optional)"
};
export const S3_PROVIDER_COPY = {
  s3: {
    endpointLabel: "S3 Endpoint URL",
    endpointHelp: "Your S3 Endpoint URL, only required if you want to override the default endpoint.",
    bucketLabel: "S3 Bucket Name",
    bucketHelp: "Your S3 Bucket name.",
    authTypeLabel: "AWS Authentication Type",
    accessKeyLabel: "AWS Access Key",
    accessKeyHelp: 'Your AWS Key should be a 20-character long, alphanumeric string that starts with the letters "AK".',
    secretKeyLabel: "AWS Secret Key",
    secretKeyResetLabel: "AWS Secrete Key",
    secretKeyHelp: "Your AWS Secret is usually a 40-character long, base-64 encoded string.",
    assumeRoleLabel: "AWS Assume Role (ARN) (optional)",
    assumeRoleHelp: "Amazon Resource Name with required cross account permission.",
    regionLabel: "AWS Region",
    regionAriaLabel: "Select AWS region",
    regionHelp: "Select an AWS region, or type a custom region for an S3-compatible provider (e.g. OVH, SysEleven).",
    regionRequiredError: "AWS Region is required when using a custom endpoint.",
    externalIdLabel: "AWS External ID (optional)"
  },
  ovh: {
    endpointLabel: "OVH Endpoint URL",
    endpointHelp: "Your OVH Object Storage endpoint URL (e.g. https://s3.gra.io.cloud.ovh.net).",
    bucketLabel: "OVH Bucket Name",
    bucketHelp: "Your OVH Object Storage bucket name.",
    ...NEUTRAL_AUTH_COPY
  },
  secunet: {
    endpointLabel: "Secunet Endpoint URL",
    endpointHelp: "Your Secunet S3-compatible storage endpoint URL.",
    bucketLabel: "Secunet Bucket Name",
    bucketHelp: "Your Secunet storage bucket name.",
    ...NEUTRAL_AUTH_COPY
  }
};
export const getS3Variant = (type) => {
  switch (type) {
    case OVH_TYPE:
      return "ovh";
    case SECUNET_TYPE:
      return "secunet";
    default:
      return "s3";
  }
};
export const isS3CompatibleType = (type) => type === S3_TYPE || type === OVH_TYPE || type === SECUNET_TYPE;
export const resolveS3CompatibleType = (type) => type === OVH_TYPE || type === SECUNET_TYPE ? S3_TYPE : type;
